import { render, staticRenderFns } from "./AxManageUsersLeave.vue?vue&type=template&id=5b459e32&"
import script from "./AxManageUsersLeave.vue?vue&type=script&lang=ts&"
export * from "./AxManageUsersLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports